// The Admin view: HR tools behind the same sign-in, reached from the header's Admin tab.
// Sections are sub-tabs; each has its own path so a link or reload lands on the same one.

import { linkTo } from "../router.js";
import { DocumentsPage } from "./DocumentsPage.js";
import { SourcesPage } from "./SourcesPage.js";

export const ADMIN_SECTIONS = [
  ["documents", "Documents"],
  ["sources", "Sources"],
] as const;
export type AdminSection = (typeof ADMIN_SECTIONS)[number][0];

export function adminSection(path: string): AdminSection {
  const s = path.split("/")[2];
  return ADMIN_SECTIONS.find(([id]) => id === s)?.[0] ?? ADMIN_SECTIONS[0][0];
}

export function Admin({ path }: { path: string }) {
  const section = adminSection(path);
  return (
    <>
      <nav className="subtabs" aria-label="Admin sections">
        {ADMIN_SECTIONS.map(([id, label]) => (
          <a
            key={id}
            href={`/admin/${id}`}
            onClick={linkTo(`/admin/${id}`)}
            aria-current={section === id ? "page" : undefined}
          >
            {label}
          </a>
        ))}
      </nav>
      {section === "documents" ? <DocumentsPage /> : null}
      {section === "sources" ? <SourcesPage /> : null}
    </>
  );
}
